"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolMetadataError = exports.SymbolMetadata = void 0;
class SymbolMetadata {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.SymbolMetadata = SymbolMetadata;
class SymbolMetadataError {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.SymbolMetadataError = SymbolMetadataError;
//# sourceMappingURL=SymbolMetadata.js.map